module.exports = __webpack_public_path__ + "img/3bb4152.png";